module.exports = __webpack_public_path__ + "img/effects-11.d37f48f7.png";